import React from 'react';
import styled from '@emotion/styled';

import { ZigzinDelayFourDays, ZigzinDelaysTwoDay, ZigzinDelayThreeDays } from '../../constant/imageUrl';

interface Props {
  days: number;
}

export const ZigzinDelayDays: React.FC<React.PropsWithChildren<Props>> = ({ days }) => {
  switch (days) {
    case 2:
      return <IslandDelayDays src={ZigzinDelaysTwoDay} />;
    case 3:
      return <IslandDelayDays src={ZigzinDelayThreeDays} />;
  }

  if (days >= 4) {
    return <IslandDelayDays src={ZigzinDelayFourDays} />;
  }

  return null;
};
const IslandDelayDays = styled.img`
  margin: 0 0 0 2px;
  width: 34px;
  height: 18px;
`;
